import React, { useEffect, useRef, useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { circle_checked } from '../../../../../../../assets/img';
import { SELECT_ALL_LABEL, TALENT_FILTER_OPTIONS } from '../../../../../../../utils/constants';
import { BasicButton } from '../../../../../../../assets/common';

const DropdownFilterTalentBuilder = (props) => {
  const {
    columns = 2,
    onChange,
    onApply,
    filterTabActive,
    keyWord,
    label,
    onClickSelectAll,
    filterName,
    placeholder,
    data,
    onNodeToggle,
    minWidth,
    onBlur,
  } = props;
  const [showApply, setShowApply] = useState(false);
  const [applyStyle, setApplyStyle] = useState({
    width: 0,
    top: 0,
  });

  const handleOnAction = (node, action) => {
    document.querySelector('.dropdown').click();
    onApply();
  };
  const dropdownRef = useRef(null);
  const getClassToAlignWidth = () => {
    return minWidth ? `min-width-${minWidth}` : ``;
  };

  const handleOnChange = (currentNode) => {
    if (currentNode.label === SELECT_ALL_LABEL) {
      onClickSelectAll(currentNode.checked);
      return;
    }
    onChange(currentNode);
  };

  useEffect(() => {
    const checkDropdownContent = () => {
      const dropdownContent = dropdownRef.current.querySelector('.dropdown-content');
      setShowApply(dropdownContent !== null);
      if (dropdownContent) {
        const HEIGHT_APPLY = 52;
        const WIDTH_SCROLL = 2;
        const heightInput = dropdownRef.current.querySelector('.filter_button').offsetHeight;
        setApplyStyle({
          width: Math.floor(dropdownContent.offsetWidth - WIDTH_SCROLL),
          top: Math.floor(dropdownContent.offsetHeight - HEIGHT_APPLY + heightInput),
        });
      }
    };

    checkDropdownContent();

    const observer = new MutationObserver(checkDropdownContent);
    observer.observe(dropdownRef.current, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [dropdownRef]);

  return (
    <div ref={dropdownRef} className={`col-${columns} filter_wrapper ${minWidth ? 'px-2' : 'px-1'} `} style={{ minWidth: minWidth + 'px' }}>
      <button
        style={{
          paddingTop: `${minWidth ? '11px' : '9px'}`,
          paddingBottom: `${minWidth ? '11px' : '9px'}`,
        }}
        className={`filter_button ${filterTabActive.includes(keyWord) ? 'active' : ''}`}
      >
        {filterTabActive.includes(keyWord) && <img src={circle_checked} alt="nofication" />}
        {!filterTabActive.includes(keyWord) ? placeholder : label}
      </button>
      <DropdownTreeSelect
        data={data}
        onNodeToggle={onNodeToggle}
        onBlur={onBlur}
        expanded={false}
        onAction={handleOnAction}
        className={
          filterName === TALENT_FILTER_OPTIONS.GENDER || filterName === TALENT_FILTER_OPTIONS.AGE
            ? 'mdl-demo fit-content custom-cln'
            : `mdl-demo ${getClassToAlignWidth()}`
        }
        checked={false}
        onChange={handleOnChange}
      />
      {showApply && (
        <div className="btn-apply" style={{ width: `${applyStyle.width}px`, top: `${applyStyle.top}px` }}>
          <BasicButton onClick={handleOnAction} mode="teal">
            Apply
          </BasicButton>
        </div>
      )}
    </div>
  );
};

export default DropdownFilterTalentBuilder;
